export default (event, app) => {
  console.log('[DisplayRewardSelection] Displaying reward selection.', event)

  app.$store.commit('order/setRewardSelector', {
    available: true,
    promotion_id: event.promotion_id,
    reward_id: event.reward_id,
    max_quantity: event.limit,
    context: event.context,
  })

  app.$store.commit('order/setPromotionsAreChecking', false)
}
